import React from "react";
import { ItemsContainer } from "./SideDrawerList.css";

// Components
import SideDrawerItem from "./SideDrawerItem";
import {
  Business,
  DriveEta,
  Person,
  Assignment,
  Build,
  SupervisorAccount,
  Shop,
  NotificationImportant
} from "@material-ui/icons";

const SideDrawerList = () => {
  return (
    <div className={ItemsContainer}>
      <SideDrawerItem text="Empresas" Icon={Business} path="/companies" />
      <SideDrawerItem text="Vehículos" Icon={DriveEta} path="/vehicles/active" />
      <SideDrawerItem text="Usuarios" Icon={Person} path="/users" />
      <SideDrawerItem text="Alertas" Icon={NotificationImportant} path="/alerts" />
      <SideDrawerItem text="Acuerdos Comerciales" Icon={Assignment} path="/agreements"/>
      <SideDrawerItem text="Requerimientos" Icon={Build} path="/requirements"/>
      <SideDrawerItem text="Proveedores" Icon={Shop} path="/providers"/>
      <SideDrawerItem text="Administradores" Icon={SupervisorAccount} path="/administrators"/>
    </div>
  );
};

export default SideDrawerList;



// WEBPACK FOOTER //
// ./src/Components/Lists/SideDrawerList/SideDrawerList.js